const labelEntities = {}
const layerProvider = {}

export {
    labelEntities,
    layerProvider
}
